import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration (replace with your actual config)
const firebaseConfig = {
    apiKey: "AIzaSyCTIISq9hx5b3twCcZPxCpINrbjCmOGylI",
    authDomain: "tipon-6rripr.firebaseapp.com",
    projectId: "tipon-6rripr",
    storageBucket: "tipon-6rripr.appspot.com",
    messagingSenderId: "289110987543",
    appId: "1:289110987543:web:58f3130d780c49f483dd52"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(firebaseApp);

export { db };
